import axios from "axios";
import firebase from "./firebase";
import request from "../infra/request";
import { orderBy } from "lodash";

export async function getUser(uid) {
  try {
    const response = await request.get(`/admin/auth/user/${uid}`);
    return { data: response.data };
  } catch (error) {
    return { error };
  }
}

export async function getUsers(roles) {
  const userIdToken = await firebase.currentUser().getIdToken();
  let endpoint = `${process.env.REACT_APP_API_HOST}/admin/auth/users`;
  if (roles) {
    endpoint += `?role=${roles.join(",")}`;
  }
  const { data } = await axios.get(endpoint, {
    headers: { Authorization: `Bearer ${userIdToken}` },
  });
  return orderBy(data, ["firstName"], ["asc"]);
}

export async function getUsersByPage(pos, filters = {}) {
  const userIdToken = await firebase.currentUser().getIdToken();
  let endpoint = `${process.env.REACT_APP_API_HOST}/admin/auth/users/page`;
  if (pos) {
    endpoint += `?curr=${[pos.curr]}&size=${pos.size}`;
  } else return;
  const { role, search, includeDisabled } = filters;
  if (role) {
    endpoint += `&role=${role}`;
  }
  if (search) {
    endpoint += `&search=${encodeURIComponent(search)}`;
  }
  if (includeDisabled) {
    endpoint += `&includeDisabled=true`;
  }
  return axios
    .get(endpoint, {
      headers: { Authorization: `Bearer ${userIdToken}` },
    })
    .then((response) => response.data);
}

function getCoreplusId(user) {
  let coreplusId = "";
  switch (user.role) {
    case "GP":
      coreplusId = user.referrerId;
      break;
    case "CLINIC_ADMIN":
      coreplusId = user.clinicId;
      break;
    case "SPECIALIST":
      coreplusId = user.specialistId;
      break;
    default:
  }
  return coreplusId;
}

export async function updateUser(user) {
  const userIdToken = await firebase.currentUser().getIdToken();
  let endpoint = `${process.env.REACT_APP_API_HOST}/admin/auth/user/${user.uid}`;
  return axios
    .put(
      endpoint,
      {
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        shortName: user.shortName,
        role: user.role,
        timezone: user.timezone,
        disabled: user.disabled,
        coreplusId: getCoreplusId(user),
        password: user.password,
        pmsId: user.pmsUserId,
      },
      {
        headers: { Authorization: `Bearer ${userIdToken}` },
      }
    )
    .then((response) => response.data);
}

export async function createUser(user) {
  const userIdToken = await firebase.currentUser().getIdToken();
  let endpoint = `${process.env.REACT_APP_API_HOST}/admin/auth/users`;
  return axios
    .post(
      endpoint,
      {
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        shortName: user.shortName,
        role: user.role,
        timezone: user.timezone,
        disabled: user.disabled,
        coreplusId: getCoreplusId(user),
        pmsId: user.pmsUserId,
        sendEmailToSpecialist: user.sendEmailToSpecialist,
      },
      {
        headers: { Authorization: `Bearer ${userIdToken}` },
      }
    )
    .then((response) => response.data);
}

export async function deleteUser(uid) {
  const userIdToken = await firebase.currentUser().getIdToken();
  let endpoint = `${process.env.REACT_APP_API_HOST}/admin/auth/user/${uid}`;
  return axios
    .delete(endpoint, {
      headers: { Authorization: `Bearer ${userIdToken}` },
    })
    .then((response) => response.data);
}

export async function getUserLoginExperience(uid) {
  const userIdToken = await firebase.currentUser().getIdToken();
  const endpoint = `${process.env.REACT_APP_API_HOST}/admin/auth/user/${uid}/login-experience`;
  return axios
    .get(endpoint, {
      headers: { Authorization: `Bearer ${userIdToken}` },
    })
    .then((response) => response.data);
}

export async function getUserFirebaseAuth(uid) {
  const userIdToken = await firebase.currentUser().getIdToken();
  const endpoint = `${process.env.REACT_APP_API_HOST}/admin/auth/user/${uid}/firebase-auth`;
  return axios
    .get(endpoint, {
      headers: { Authorization: `Bearer ${userIdToken}` },
    })
    .then((response) => response.data);
}

export async function updateUserLoginExperience(uid, enabled) {
  const userIdToken = await firebase.currentUser().getIdToken();
  const endpoint = `${process.env.REACT_APP_API_HOST}/admin/auth/user/${uid}/login-experience`;
  return axios
    .put(
      endpoint,
      { enabled },
      {
        headers: { Authorization: `Bearer ${userIdToken}` },
      }
    )
    .then((response) => response.data);
}

export async function updateUserEmailVerification(uid, emailVerified) {
  const userIdToken = await firebase.currentUser().getIdToken();
  const endpoint = `${process.env.REACT_APP_API_HOST}/admin/auth/user/${uid}/email-verification`;
  return axios
    .put(
      endpoint,
      { emailVerified },
      {
        headers: { Authorization: `Bearer ${userIdToken}` },
      }
    )
    .then((response) => response.data);
}
